export default {"src":"/_next/static/media/slalom.967b6326.svg","height":75,"width":288,"blurWidth":0,"blurHeight":0};